<app-dialog
  headerText="Configure Table Columns"
  [headerGlyph]="[$any('workspace'), $any('tableSettings')]"
  saveText="Apply"
  [body]="body"
  (save)="this.dialogRef.close(this.columns)"
  [validationFn]="isValid.bind(this)"
></app-dialog>

<ng-template #body>
  <div class="reset-wrap">
    <button
      id="reset-button"
      fd-button
      [fdType]="'transparent'"
      [disabled]="!isDirty"
      label="Reset"
      (click)="reset()"
    ></button>
  </div>
  <ul
    fd-list
    [selection]="true"
    cdkDropList
    (cdkDropListDropped)="dropHandle($event)"
    [ngClass]="'column-list'"
    [cdkDropListSortPredicate]="dropListEnterPredicate(columns)"
  >
    @for (column of columns; track column; let rowIndex = $index) {
      <li
        fd-list-item
        cdkDrag
        cdkDragLockAxis="y"
        class="list-item"
        [cdkDragData]="column"
        [cdkDragDisabled]="column.disabled"
        (cdkDragMoved)="onHover(null)"
        [ngClass]="column.disabled ? 'disabled-item' : ''"
        (mouseenter)="onHover(column)"
        (mouseleave)="onHover(null)"
      >
        <div class="list-item-content">
          <fd-checkbox
            class="list-checkbox"
            [name]="column.key"
            [(ngModel)]="column.checked"
            (ngModelChange)="handleChange(column, $event)"
            [disabled]="column.disabled"
            [label]="column.key"
          >
          </fd-checkbox>
          @if (currentColumn === column && column.checked) {
            <div class="buttons-wrap">
              <button
                fd-button
                id="top-button"
                [ngClass]="'order-button'"
                [disabled]="isMoveButtonDisabled(MoveButtonType.Top, rowIndex)"
                (click)="
                  onMoveButtonPress($event, MoveButtonType.Top, rowIndex)
                "
                [fdCompact]="true"
                [fdType]="'transparent'"
                glyph="collapse-group"
                title="Move to Top"
              ></button>
              <button
                fd-button
                id="up-button"
                [ngClass]="'order-button'"
                [disabled]="isMoveButtonDisabled(MoveButtonType.Up, rowIndex)"
                (click)="onMoveButtonPress($event, MoveButtonType.Up, rowIndex)"
                [fdCompact]="true"
                [fdType]="'transparent'"
                glyph="navigation-up-arrow"
                title="Move Up"
              ></button>
              <button
                fd-button
                id="down-button"
                [ngClass]="'order-button'"
                [disabled]="isMoveButtonDisabled(MoveButtonType.Down, rowIndex)"
                (click)="
                  onMoveButtonPress($event, MoveButtonType.Down, rowIndex)
                "
                [fdCompact]="true"
                [fdType]="'transparent'"
                glyph="navigation-down-arrow"
                title="Move Down"
              ></button>
              <button
                fd-button
                id="bottom-button"
                [ngClass]="'order-button'"
                [disabled]="
                  isMoveButtonDisabled(MoveButtonType.Bottom, rowIndex)
                "
                (click)="
                  onMoveButtonPress($event, MoveButtonType.Bottom, rowIndex)
                "
                [fdCompact]="true"
                [fdType]="'transparent'"
                glyph="expand-group"
                title="Move to Bottom"
              ></button>
            </div>
          }
        </div>
      </li>
    }
  </ul>
</ng-template>
